import type { UnitInfoTextInterface } from '.';
import { screenDeckDisplay } from './utils';
import type { DeckCheckboxConfig } from 'containers/PropertyPanel/components/ScreenDeckDisplay';
import type { DeckPropertyConfig } from './deckDisplayConfigs';

export const getDeckCheckboxes = <
  TDeck extends { display: Record<string, boolean> },
>(
  deck: TDeck,
  properties: DeckPropertyConfig<TDeck>[],
  deckIndex: number,
  nbrOfDecks: number,
  onChange: (key: keyof TDeck['display'], value: boolean) => void,
): DeckCheckboxConfig[] => {
  if (!deck.display) {
    return properties.map((prop) => ({
      value: false,
      onChange: (val: boolean) => onChange(prop.key, val),
      label: deckIndex === nbrOfDecks - 1 ? prop.label : '',
    }));
  }

  return properties.map((prop) => ({
    value: deck.display[prop.key as string],
    onChange: (val: boolean) => onChange(prop.key, val),
    label: deckIndex === nbrOfDecks - 1 ? prop.label : '',
  }));
};

export const deckDisplayFromConfig = <
  TDeck extends { display: Record<string, boolean> },
>(
  deck: TDeck,
  properties: DeckPropertyConfig<TDeck>[],
  deckIndex: number,
  textArray: UnitInfoTextInterface[],
  deckName?: string,
) => {
  const deckProperties = properties.map((prop) => ({
    text: prop.getText(deck),
    display: deck.display ? deck.display[prop.key as string] : false,
  }));

  screenDeckDisplay(deckIndex, textArray, deckProperties, deckName);
};

export const renderDecksFromConfig = <
  TDeckList,
  TDeck extends { display: Record<string, boolean> } = any,
>(
  deckList: TDeckList,
  nbrOfDecks: number,
  properties: DeckPropertyConfig<TDeck>[],
  textArray: UnitInfoTextInterface[],
  deckNames?: string[],
) => {
  Object.values(deckList as any).forEach((deck: any, index: number) => {
    if (index < nbrOfDecks) {
      deckDisplayFromConfig(
        deck,
        properties,
        index,
        textArray,
        deckNames?.[index],
      );
    }
  });
};
